module.exports = {
    "id": "chichi-chase",
    "title": "chichi's chase",
    "character-image": "/provision/projects/chichi-chase/chichi.png",
    "project_file": "chichi-chase.gbp",
    "thumbnail": "/provision/projects/chichi-chase/chichi-chase.png",
    "category": "games",
    "toolbar":{
      "glitches":[],
      "parts":[]
    }
  };